'use client';

import { useEffect, useRef } from 'react';
import { useSessionContext } from '@users/session/SessionContext';
import { getContainer } from '@framework/di/getContainer';
import TrackingConsent from '@framework/cookie-consent/TrackingConsent';
import { ConsentCategory } from '@framework/cookie-consent/constants';
import GoogleAnalytics from './GoogleAnalytics';
import GoogleAnalyticsBaseEvents from './GoogleAnalyticsBaseEvents';
import initGoogleTagManager from './googleTagManager';

const GoogleAnalyticsProvider = ({ nonce = '' }: { nonce?: string }): React.JSX.Element | null => {
  const { initialized, currentUser } = useSessionContext();
  const initializedRef = useRef(false);
  const trackingConsent = getContainer().get(TrackingConsent);

  useEffect(() => {
    if (!initialized || initializedRef.current) {
      return undefined;
    }

    const initGA = (): void => {
      if (initializedRef.current) return;
      initializedRef.current = true;

      initGoogleTagManager(nonce);
      const isGAInitialized = GoogleAnalytics.init(currentUser, nonce);

      if (isGAInitialized) {
        GoogleAnalyticsBaseEvents.trackPageView();
        window.addEventListener('locationchange', GoogleAnalyticsBaseEvents.trackPageView);
      }
    };

    trackingConsent.onConsent(ConsentCategory.Marketing, initGA);

    return () => {
      window.removeEventListener('locationchange', GoogleAnalyticsBaseEvents.trackPageView);
    };
  }, [initialized]);

  return null;
};

export default GoogleAnalyticsProvider;
